import ContactCard from "shared/components/data-display/drawers/ContactCard";
import PropTypes from "prop-types";
import { InputLabel } from "../custom-styles/new-edit-form/NewEditForm.styles";
import React from "react";
import VStack from "shared/components/layout/stack/VStack";
import env from "react-dotenv";

const ReviewerCard = ({ approver }) => {
    return (
        <VStack spacing="Zero_25">
            <InputLabel
                variant="Body_2_2"
                color="Gray_1"
            >
                Reviewer
            </InputLabel>
            <ContactCard
                photoUrl={
                    env.BESTWORK_REACT_ASSET_DOMAIN +
                    "/" +
                    approver?.data.SmallPhotoUrl
                }
                name={approver?.data.FullName}
                jobPost={approver?.data.Title}
                department={
                    approver?.data.Department
                }
                emailId={approver?.data.Email}
                contactCardLabel=""
            />
        </VStack>
    );
};

ReviewerCard.propTypes = {
    approver: PropTypes.object
};

export default ReviewerCard;
